import styled, { css } from 'styled-components';

const dragActive = css`
    border-color: #1c0506;
`

const dragReject = css`
    border-color: #c32027;
`

const haveImage = css`
    border-color: #1c0506;
    background-color: #faf8f8;
`

export const DropContainer = styled.div.attrs({
    className: "dropzone"
})`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    outline: none;
    height: 9.5rem;
    width: 100%;
    max-width: 663px;
    border: 2px dashed #a09c9d;
    border-radius: 8px;
    cursor: pointer;

    transition: height 0.2s ease;

    ${props => props.haveImage && haveImage};
    ${props => props.isDragActive && dragActive};
    ${props => props.isDragReject && dragReject};

    font-family: Montserrat;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: normal;
    font-size: 16px;

    @media (max-width: 360px) {
        height: 11rem;
    }

    .icon-image {
        margin-bottom: 1rem;
    }

    .bold {
        font-weight: 600;
    }

    .nome {
        margin-bottom: 16px;
        font-weight: 700;
        width: 88%; 
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1; /* number of lines to show */
        -webkit-box-orient: vertical;
    }
`;

const messageColors = {
    default: '#2a0709',
    error: '#c32027',
    success: '#1c0506',
};

export const UploadMessage = styled.div`
    display: flex;
    flex-direction: column;
    color: ${props => messageColors[props.type || 'default']};
    justify-content: center;
    align-items: center;
`;

export const Container = styled.div`
    -webkit-filter: blur(0px);
    width: 100%;
    height: 100%;
    overflow: visible;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    // -webkit-touch-callout: none;
    // -webkit-user-select: none;
    // -khtml-user-select: none;
    // -moz-user-select: none;
    // -ms-user-select: none;
    // user-select: none;
    -webkit-tap-highlight-color: transparent;

    .div-invalido {
            width: 95%;
            max-width: 540px;
            overflow: hidden;
            box-sizing: border-box;
            margin-top: 1rem;

            .texto-invalido {
                font-family: Montserrat;
                font-size: 12px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                color: #c42027;
                float: left;
                cursor: default;
            }
        }

    p {
        margin: 0;
        padding: 0;
    }

    hr {
        display: none;

        @media (max-width: 691px) {
            display: block; 
            height: 1px;
            border: 0; 
            border-top: 2px solid #f3f3f3;
            margin: 2em 0; 
            padding: 0;
        }
    }

    .header {
        display: flex;
        flex-direction: column;
        max-width: 560px;
        padding: 2rem;
        padding-top: 3rem;

        @media (max-width: 420px) {
            padding-top: 40px;
            padding-left: 16px;
            max-width: 291px;
        }

        @media (max-width: 600px) {
            padding-left: 16px;
            max-width: 400px;
        }

        img {
            width: 32px;
            height: 32px;
            margin: 0px;
            padding: 0px;
            object-fit: contain;
        }

        h1 {
            font-family: Montserrat;
            font-size: 2rem;
            margin: 0;
            padding: 0;
            padding-top: 2rem;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            @media(max-width: 420px) {
                    font-size: 1.5rem;
                }
        }

        h5 {
            margin: 0;
            padding: 0;
            padding-top: 1.5rem;
            font-size: 1rem;
            font-weight: normal;
            font-family: Montserrat;
            color: #a49b9b;
            line-height: 2;
            max-width: 416px;
        }
    }

    .botao-div {
        display: flex;
        padding: 2rem;
        padding-top: 0.5rem;

        @media(max-width: 691px) {
            padding: 1rem;
        }
            
        .salvar {
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
            @media(max-width: 691px) {
                width: 100%;
            }
        }

        .salvar-branco {
            /* margin-bottom: -56px;  */
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #fff;
            border: 1px solid #c32027;
            outline: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #c32027;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #faf8f8
            }

            :active {
                background-color: #dedede
            }
            @media(max-width: 360px) {
                width: 100%;
            }
        }
    }

    h1 {
        font-family: Montserrat;
        font-size: 2rem;
        margin: 0;
        padding: 0;
        margin-top: 1.5rem;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        @media(max-width: 420px) {
            font-size: 1.5rem;
        }
    }

    h5 {
        margin: 0;
        padding: 0;
        padding-top: 1.5rem;
        font-size: 1rem;
        font-weight: normal;
        font-family: Montserrat;
        color: #a49b9b;
        line-height: 2;
        max-width: 416px;
    }

    h4 {
        margin: 0;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        @media(max-width: 360px) {
        }
    }

    .info {
        padding: 2rem;
        padding-right: 0;

        @media(max-width: 691px) {
            padding: 1rem;
            // padding-top: 4rem;

            h4 {
                padding-bottom: 2.5rem
            }
        }
    }
    .imagem {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 1rem
        }

        .foto {
            padding-top: 2.5rem;

            .preview {
                transition: 0.2s;
                cursor: pointer;
                width: 11.5rem;
                height: 9.5rem;
                border: 1px solid #dedede;
                border-radius: 8px;
                display:flex;
                align-items: center;
                justify-content: center;
                position: relative;

                img {
                    transition: 0.2s;
                    width: 11.5rem;
                    height: 9.5rem;
                    border-radius: 8px;
                    overflow: hidden;
                    object-fit: cover;
                }

                .imagem {
                    width: 11.5rem;
                    height: 9.5rem;
                    transition: 0.2s;
                    opacity: 1;
                }

                .lixeira {
                    opacity: 0;
                    transition: 0.2s;
                    z-index: 9;
                    position: absolute;
                    align-self: center;
                    width: 2.5rem;
                    height: 2.5rem;
                }

                :hover {
                        .imagem {
                            opacity: 0.5;
                        }
                        .lixeira {
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }

    .obrigatorio {
        padding: 2rem;

        .options  {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            flex-direction: row;
            padding-top: 2.5rem;
            @media(max-width: 360px) {
                width: 100%
            }
            .option {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;
                @media(max-width: 360px) {
                    padding: 6px 14px;
                }
                @media(max-width: 784px) {
                    padding: 12px 24px;
                }
                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #2a0709;
                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }
            .option-selected {
                cursor: pointer;
                margin-right: 16px;
                margin-bottom: 16px;
                background-color: #2a0709;
                border: 2.5px solid #2a0709;
                border-radius: 100px;
                padding: 12px 32px;
                @media(max-width: 360px) {
                    padding: 6px 14px;
                }
                @media(max-width: 784px) {
                    padding: 12px 24px;
                }
                span {
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    color: #fff;
                    @media(max-width: 360px) {
                        font-size: 13px;
                    }
                }
            }
        }
    }

    .min-max {
        display: flex;
        flex-direction: row;
        padding: 2rem;

        .counter {
            margin-top: 2.5rem;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            width: 11.5rem;
            height: 5.5rem;
            border-radius:  0.5rem;
            border: 1px solid #dedede;

            span {
                transition: 0.2s;
                font-family: Montserrat;
                font-size: 1rem;
                font-weight: 600;
                color: #1c0506;
            }

            button {
                transition: 0.2s;
                cursor: pointer;
                border: none;
                outline: none;
                background: transparent;

                .icon {
                    font-size: 1.5rem;
                }
            }
        }

        .min {
            display: flex;
            flex-direction: column;
            align-items: left;
            justify-content: center;
            margin-right: 2.5rem;
        }

        .max {
            display: flex;
            flex-direction: column;
            align-items: left;
            justify-content: center;
        }
    }

    .preco {
        padding: 2rem;
    }

    .itens {
        padding: 2rem;
    }

    .close {
        position: absolute;
        right: 32px;
        top: 32px;

        @media(max-width: 600px) {
                right: 10px;
                top: 10px;
            }
        
        button {
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;

            .i-close {
                vertical-align: middle;
                align-self: center;
                font-size: 36px;
                top: 10px;
                bottom: 10px;
                left: 10px;
                right: 10px;
                color: #c0b7b8 !important;

                @media(max-width: 600px) {
                    font-size: 26px;
                    top: 16px;
                    bottom: 16px;
                    left: 16px;
                    right: 16px;
                }
            }
        }
    }

    .div-input {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 600px) {
            width: 100%;
            height: 64px;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        @media(max-width: 600px) {
            height: 64px;
            align-self: center;
            margin-top: 36px;
            margin-left: 0;
        }
    }

    .div-input-focado {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 600px) {
            width: 100%;
            height: 64px;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-focado-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        @media(max-width: 600px) {
            height: 64px;
            align-self: center;
            margin-top: 36px;
            margin-left: 0;
        }
    }

    .div-input-error {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 600px) {
            width: 100%;
            height: 64px;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-error-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        @media(max-width: 600px) {
            height: 64px;
            align-self: center;
            margin-top: 36px;
            margin-left: 0;
        }
    }

    .div-input input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #1c0506;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;
    }

    .div-input-focado input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-focado-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #1c0506;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;
    }

    .div-input-error input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #c42027;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-error-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #c42027;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;
    }

    .div-input label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-focado label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-focado-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-error label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-error-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .content-name {
        position: absolute;
        bottom: 8px;
        left: 0px;
        transition: all 0.3s ease;
    }

    .div-input input:focus + .label-name .content-name,
    .div-input input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-box textarea:focus + .label-name .content-name,
    .div-input-box textarea:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-box::after {
            border: none;
        }
    }

    .div-input-focado input:focus + .label-name .content-name,
    .div-input-focado input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado::after {
            border: none;
        }
    }

    .div-input-focado-box textarea:focus + .label-name .content-name,
    .div-input-focado-box textarea:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado-box::after {
            border: none;
        }
    }

    .div-input-error input:focus + .label-name .content-name,
    .div-input-error input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error::after {
            border: none;
        }
    }

    .div-input-error-box textarea:focus + .label-name .content-name,
    .div-input-error-box textarea:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error-box::after {
            border: none;
        }
    }

    .div-input input:focus + .label-name::after,
    .div-input input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-box textarea:focus + .label-name::after,
    .div-input-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado input:focus + .label-name::after,
    .div-input-focado input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado-box textarea:focus + .label-name::after,
    .div-input-focado-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error input:focus + .label-name::after,
    .div-input-error input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error-box textarea:focus + .label-name::after,
    .div-input-error-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-focado button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-error button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }
`